import { FC, forwardRef } from 'react';
import { StyleSheet } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { Button, ButtonProps } from '@ui-kitten/components';

export const IconButton = forwardRef<Button, Props>(
	({ Icon, size = 'medium', style, ...props }, ref) => {
		return (
			<Button
				accessoryLeft={<Icon width={32} height={32} />}
				style={[styles.button, getButtonStyle(size), style]}
				ref={ref}
				{...props}
			/>
		);
	},
);

const styles = StyleSheet.create({
	button: {
		minWidth: 16,
		minHeight: 16,
		paddingHorizontal: 0,
	},
});

const sizes = {
	small: 32,
	medium: 40,
	large: 48,
};

const getButtonStyle = (size: NonNullable<Props['size']>) => ({
	width: sizes[size],
	height: sizes[size],
	borderRadius: sizes[size] / 2,
});

type Props = {
	Icon: FC<SvgProps>;
	size?: 'small' | 'medium' | 'large';
} & Omit<ButtonProps, 'accessoryLeft' | 'accessoryRight' | 'size'>;
